import PanelCobranzas from './modulos/cobranzas/PanelCobranzas';
import React, { useContext, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Login from './modulos/login/Login';
import Diseno from './comun/Diseno';
import ListaUsuarios from './modulos/usuarios/ListaUsuarios';
import ServicePlaceholder from './components/ServicePlaceholder';
import PanelHeladeria from './modulos/heladeria/PanelHeladeria';
import Inventario from './modulos/heladeria/Inventario';
import Bodega from './modulos/heladeria/Bodega';
import Mezclas from './modulos/heladeria/Mezclas';
import Ordenes from './modulos/heladeria/Ordenes';
import Clientes from './modulos/heladeria/Clientes';
import Reportes from './modulos/heladeria/Reportes';
import ReportesPeriodicos from './modulos/heladeria/ReportesPeriodicos';
import PuntosVenta from './modulos/heladeria/PuntosVenta';
import PanelCaja from './modulos/heladeria/Caja/PanelCaja';
import Impresoras from './modulos/heladeria/Impresoras';
import Promociones from './modulos/heladeria/Promociones';
import DisenoHeladeria from './modulos/heladeria/DisenoHeladeria';
import Gastos from './modulos/heladeria/Gastos';
import Toppings from './modulos/heladeria/Toppings';
import Variables from './modulos/heladeria/Variables';

import SincronizacionContifico from './modulos/heladeria/SincronizacionContifico';
import logo from './assets/logo.png';
import './App.css';

// Componente para proteger rutas

const GestorCobranzasRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;
  const roleName = user?.role_details?.name;
  if (roleName !== 'GESTOR_COBRANZAS' && !user?.is_superuser) {
    return <Navigate to="/" />;
  }
  return <Diseno>{children}</Diseno>;
};

const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Diseno>{children}</Diseno>;
};

const HeladeriaRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;
  const roleName = user?.role_details?.name;
  if (roleName === 'GESTOR_COBRANZAS') {
    return <Navigate to="/cobranzas" />;
  }

  // Usamos el diseño general para todos, la barra lateral filtrará los items
  return <Diseno>{children}</Diseno>;
};

// Dashboard simple
const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const roleName = user?.role_details?.name;
  
  if (roleName !== 'SUPER_ADMIN' && !user?.is_superuser) {
      return <Navigate to="/heladeria/pos" />;
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '80vh',
      backgroundColor: 'var(--secondary-color)',
      color: 'var(--primary-color)',
      textAlign: 'center',
      borderRadius: '16px',
      padding: '3rem',
      margin: '1rem',
      boxShadow: '0 4px 20px rgba(100, 16, 14, 0.1)'
    }}>
      <img src={logo} alt="Choco Lab" style={{ height: '180px', marginBottom: '2rem', objectFit: 'contain', filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))' }} />
      <h2 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>Bienvenido a Choco Lab</h2>
      <p style={{ fontSize: '1.2rem', opacity: 0.9 }}>Seleccione una opción del menú lateral para comenzar a administrar su negocio.</p>
    </div>
  );
};

// ===== BANNER DE PWA =====
const PWAInstallBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Detectar si la app está instalada
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      console.log('?? App instalada como PWA');
    }

    // Detectar evento de instalación
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      console.log('?? La app se puede instalar');
      setShowBanner(true);
      // Guardar evento para mostrar botón personalizado
      window.deferredPrompt = e;
    });

    window.addEventListener('appinstalled', () => {
      console.log('?? App instalada exitosamente');
      setIsInstalled(true);
      setShowBanner(false);
    });

    // Detectar si ya está instalada desde el inicio
    if (window.navigator.standalone) {
      setIsInstalled(true);
    }
  }, []);

  const handleInstallClick = async () => {
    const deferredPrompt = window.deferredPrompt;
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        console.log('? Usuario aceptó la instalación');
        setShowBanner(false);
      } else {
        console.log('? Usuario rechazó la instalación');
      }
      window.deferredPrompt = null;
    }
  };

  if (isInstalled) {
    return (
      <div style={{
        background: '#4CAF50',
        color: 'white',
        padding: '4px 10px',
        textAlign: 'center',
        fontSize: '12px',
        fontWeight: 'bold',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999
      }}>
        ? App instalada
      </div>
    );
  }

  if (!showBanner) return null;

  return (
    <div style={{
      background: 'var(--primary-color)',
      color: 'white',
      padding: '12px 20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
      animation: 'slideUp 0.5s ease'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <img src={logo} alt="KEKALA" style={{ height: '40px', borderRadius: '8px' }} />
        <div>
          <div style={{ fontWeight: 'bold', fontSize: '16px' }}>Instalar KEKALA</div>
          <div style={{ fontSize: '12px', opacity: 0.9 }}>Instala esta app para mejor experiencia</div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: '10px' }}>
        <button
          onClick={() => setShowBanner(false)}
          style={{
            background: 'transparent',
            border: '1px solid rgba(255,255,255,0.3)',
            color: 'white',
            padding: '8px 16px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Cerrar
        </button>
        <button
          onClick={handleInstallClick}
          style={{
            background: 'white',
            border: 'none',
            color: 'var(--primary-color)',
            padding: '8px 20px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '14px'
          }}
        >
          Instalar
        </button>
      </div>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <PWAInstallBanner />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />

          <Route path="/users" element={
            <PrivateRoute>
              <ListaUsuarios />
            </PrivateRoute>
          } />

          {/* Rutas de creación/edición eliminadas porque ahora son Modales */}

          <Route path="/heladeria" element={
            <HeladeriaRoute>
              <PanelHeladeria />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/inventory" element={
            <HeladeriaRoute>
              <Inventario />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/promotions" element={
            <HeladeriaRoute>
              <Promociones />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/bodega" element={
            <HeladeriaRoute>
              <Bodega />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/mezclas" element={
            <HeladeriaRoute>
              <Mezclas />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/toppings" element={
            <HeladeriaRoute>
              <Toppings />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/variables" element={
            <HeladeriaRoute>
              <Variables />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/orders" element={
            <HeladeriaRoute>
              <Ordenes />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/customers" element={
            <HeladeriaRoute>
              <Clientes />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/reports" element={
            <HeladeriaRoute>
              <Reportes />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/periodic-reports" element={
            <HeladeriaRoute>
              <ReportesPeriodicos />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/pos" element={
            <HeladeriaRoute>
              <PuntosVenta />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/shift" element={
            <HeladeriaRoute>
              <PanelCaja />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/feria-shift" element={
            <HeladeriaRoute>
              <PanelCaja isFeriaMode={true} />
            </HeladeriaRoute>
          } />
          <Route path="/heladeria/gastos" element={
            <HeladeriaRoute>
              <Gastos />
            </HeladeriaRoute>
          } />

          
          <Route path="/heladeria/sync" element={
            <HeladeriaRoute>
              <SincronizacionContifico />
            </HeladeriaRoute>
          } />

          <Route path="/heladeria/printers" element={
            <HeladeriaRoute>
              <Impresoras />
            </HeladeriaRoute>
          } />

          <Route path="/hotel" element={
            <PrivateRoute>
              <ServicePlaceholder title="Hotel" />
            </PrivateRoute>
          } />

          <Route path="/pool" element={
            <PrivateRoute>
              <ServicePlaceholder title="Piscinas" />
            </PrivateRoute>
          } />

          <Route path="/restaurant" element={
            <PrivateRoute>
              <ServicePlaceholder title="Restaurante" />
            </PrivateRoute>
          } />

          {/* Redirigir cualquier otra ruta al inicio */}
          <Route path="/cobranzas" element={
            <GestorCobranzasRoute>
              <PanelCobranzas />
            </GestorCobranzasRoute>
          } />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
